<section class="d-flex justify-content-start align-items-start">
  <div>ICON</div>
  <div>
    <h1>¡Muchas gracias!</h1>
    <span>La información será provista a SEUR para continuar con el envío.</span>
    <span>Ya puedes cerrar esta pestaña.</span>
  </div>
</section>